"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = require("../types/index");
var _default = exports.default = {
  type: _index.ETH,
  service: 'myetherwallet.com-ws',
  url: 'wss://nodes.mewapi.io/ws/eth',
  port: 443,
  auth: false,
  username: '',
  password: ''
};